module.exports = __webpack_public_path__ + "img/person-login.a4b13ccc.png";